import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Stamp } from "./Stamp";
import { LogoMark } from "./Logo";
import { EMAIL, PHONE, PHONE_LABEL, COLLAB, ADDRESS, mailto } from "./data";

export const Footer = () => (
  <footer id="contatti" data-testid="site-footer" className="bg-[#F4EFE6] text-[#2A1C15] pt-24 sm:pt-36 pb-28 sm:pb-32 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#8C4A28] mb-6">Contatti</p>
          <h2 className="font-serif text-5xl sm:text-7xl leading-[0.95] tracking-tight">
            Richiedi il tuo <em className="text-[#C9692C]">preventivo.</em>
          </h2>
          <p className="mt-6 max-w-lg text-base sm:text-lg text-[#2A1C15]/75">Per la casa, per il tuo negozio o per grandi quantità: scrivici o chiamaci, ti rispondiamo noi.</p>
        </Reveal>
        <Reveal delay={0.2} className="lg:col-span-4 flex lg:justify-end">
          <Stamp className="w-36 h-36 sm:w-44 sm:h-44" />
        </Reveal>
      </div>

      <div className="mt-16 grid md:grid-cols-2 gap-5">
        <a href={mailto("Richiesta preventivo pellet")} data-testid="footer-email-link" className="group flex items-center justify-between gap-4 rounded-3xl bg-[#1A110C] text-[#FDFBF7] p-7 sm:p-10 hover:-translate-y-1 transition-transform">
          <span>
            <span className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#E8893F]"><Mail className="w-4 h-4" /> Email</span>
            <span className="mt-3 block font-serif text-[22px] sm:text-4xl break-words">{EMAIL}</span>
          </span>
          <ArrowUpRight className="w-8 h-8 shrink-0 text-[#E8893F] transition-transform group-hover:rotate-45" />
        </a>
        <a href={`tel:${PHONE}`} data-testid="footer-phone-link" className="group flex items-center justify-between gap-4 rounded-3xl bg-[#E8893F] text-[#1A110C] p-7 sm:p-10 hover:-translate-y-1 transition-transform">
          <span>
            <span className="flex items-center gap-2 text-xs uppercase tracking-[0.25em]"><Phone className="w-4 h-4" /> Chiama ora</span>
            <span className="mt-3 block font-serif text-2xl sm:text-4xl">{PHONE_LABEL}</span>
          </span>
          <ArrowUpRight className="w-8 h-8 shrink-0 transition-transform group-hover:rotate-45" />
        </a>
      </div>

      <p aria-hidden="true" className="mt-20 font-serif leading-[0.8] tracking-[-0.04em] text-[15vw] lg:text-[13.5rem] text-[#2A1C15] whitespace-nowrap">
        Pellet <em className="text-[#C9692C]">Italiana</em>
      </p>

      <div className="mt-10 pt-8 border-t border-[#2A1C15]/15 flex flex-col md:flex-row gap-4 md:items-center justify-between text-sm text-[#2A1C15]/75">
        <span className="flex items-center gap-3"><LogoMark className="w-7 h-7" /> © {new Date().getFullYear()} Pellet Italiana · <span data-testid="footer-domain">pelletitaliana.it</span></span>
        <span data-testid="footer-address">{ADDRESS}</span>
        <span className="capitalize-first">{COLLAB}</span>
        <a href={`mailto:${EMAIL}`} data-testid="footer-email-bottom" className="hover:text-[#C9692C] transition-colors">{EMAIL}</a>
      </div>
    </div>
  </footer>
);
